// extracted by mini-css-extract-plugin
module.exports = {"startGameButton":"Scene_startGameButton__BeuMr","homeContainer":"Scene_homeContainer__2ZHeO","heroContainer":"Scene_heroContainer__1p_Z2","storyList":"Scene_storyList__3az5u"};